import React, { Component } from "react";
import MicrosoftLogin from "react-microsoft-login";
import { ID_CLIENTE_MICROSOFT } from "../constants/action-types";

class LoginMicrosoft extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        const authHandler = (err, data) => {
            if (err) {
                console.error("Error de autenticación Microsoft:", err);
                this.props.functionToken("ERROR");
            } else {
                console.log("Datos de autenticación:", data);
                this.props.functionToken(data);
            }
        };

        return (
            <MicrosoftLogin
                clientId={ID_CLIENTE_MICROSOFT}
                authCallback={authHandler}
                graphScopes={["user.read", "openid", "profile", "email"]} // Añade scopes necesarios
                redirectUri="https://serviciosweb.konradlorenz.edu.co/digiturno/"
                withUserData={true} // Incluye datos del usuario en la respuesta
            />
        );
    }
}

export default LoginMicrosoft;

